import { authHeader } from "./session";
import { getUrl } from "./connection";
import { loading } from "./stores/loading";
import { alert } from "./stores/alert";
import { translate, getLang } from "./i18n";

const uploadFile = async (formData) => {
    console.log("Current language: " + getLang());
    loading.newLoading();
    const [url, method] = await getUrl("importlibraryxls");

    try {
        const response = await fetch(url, {
            method: method,
            headers: {
                ...authHeader()
            },
            body: formData
        });
    
        if (response.ok) {
            const result = await response.json();
            const summary = result.response?.summary;
            let summaryMessage = "";
            if (summary) {
                summaryMessage = translate("library.uploadSummary");
                const total = Object.values(summary).reduce((total, value) => total + value, 0);
                summaryMessage = summaryMessage.replace("{n}", total);
            }
            alert.newAlert({ message: summaryMessage ? summaryMessage : translate("library.uploadSuccess"), type: "successful" });
            return "";
        }
        else if (response.status === 500) {
            alert.newAlert({ message: translate("library.uploadGenericError") + `. ${response.statusText}`, type: "error" });
            return translate("library.uploadGenericError") + `. ${response.statusText}`;
        }
        else if (response.status === 422) {
            try {
                const result = await response.json();
                const errMsg = translate("library.uploadImportError") + ` ${result.message}`;
                alert.newAlert({ message: errMsg, type: "error" });
                return errMsg;
            }
            catch (err) {
                return translate("library.uploadGenericError") + `. ${response.statusText}`;
            }
        }
        else {
            alert.newAlert({ message: translate("library.uploadGenericError") + `. ${response.statusText}`, type: "error" });
            return translate("library.uploadGenericError") + `. ${response.statusText}`;
        }
    }
    catch (err) {
        alert.newAlert({ message: translate("library.uploadGenericError"), type: "error" });
        return translate("library.uploadGenericError") + `. ${response.statusText}`;
    }
    finally {
        loading.removeLoading();
    }
}

export { uploadFile }
